import { lazy } from "react";

import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";
import { getFirstEnabledDeliverabilityRoute } from "@lib/deliverability/getFirstEnabledDeliverabilityRoute";

const DeliverabilityRedirect = lazy(() =>
  import("@scenes/AnalyticsDashboard/Deliverability/DeliverabilityRedirect").then((module) => ({
    default: module.DeliverabilityRedirect,
  }))
);

export const dashboardAnalyticsDashboardDeliverabilityNRO: NavigationRoutingObject = {
  Component: DeliverabilityRedirect,
  componentFeatureFlippers: [],
  noKnockoutFallback: true,
  section: "analytics",
  heading: (t: I18nT<"dashboard-navigation">) => t("deliverability-sidebar-pill-menu-option", "Deliverability"),
  pageNameForTracking: () => "Deliverability",
  tag: "new",
  getDeveloperNavigationAllowed: ({ featureOn, hasPermission, isImpersonating }) => {
    const userHasPermission =
      isImpersonating ||
      hasPermission("appGroup", { permission: "viewAppUsage" }) ||
      hasPermission("appGroup", { permission: "viewReporting" });
    return getFirstEnabledDeliverabilityRoute(featureOn) !== null && userHasPermission;
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
};
